import { Icon } from '@chakra-ui/react';

export const BookmarkIcon = (props: any) => (
  <Icon aria-label="bookmark icon" viewBox="4 4 16 16" {...props}>
    <path
      d="m7.625 6h8.75c.345178 0 .625.30029113.625.67071901v11.65841509c0 .3704278-.279822.670719-.625.670719-.0970282 0-.1927239-.0242432-.2795085-.0708097l-3.815983-2.0475619c-.1759547-.0944129-.3830623-.0944129-.559017 0l-3.815983 2.0475619c-.30873656.1656604-.68415721.0313661-.83852549-.2999547-.04339233-.093133-.06598301-.1958288-.06598301-.2999546v-11.65841509c0-.37042788.27982203-.67071901.625-.67071901z"
      fill="currentColor"
    />
  </Icon>
);
